import { AgeGroupEnum } from '../../../types/enums/age-group.enum';
import { AgeGroup } from './age-group-select.component';

export const ageGroupArray: AgeGroup[] = [
	{ name: AgeGroupEnum.underForty, label: 'order.subcomponents.ageGroup.texts.39' },
	{ name: AgeGroupEnum.aboveForty, label: 'order.subcomponents.ageGroup.texts.70' },
];
